/** @flow */

// Client list
export const AddClientDetails = "ADD_CLIENT_DETAILS";
export const AddClientDetailsSuccess = "ADD_CLIENT_DETAILS_SUCCESS";
export const AddClientDetailsError = "ADD_CLIENT_DETAILS_ERROR";
export const GetClient = "GET_CLIENT";
export const GetClientSuccess = "GET_CLIENT_SUCCESS";
export const GetClientError = "GET_CLIENT_ERROR";
export const GetClients = "GET_CLIENTS";
export const GetClientsSuccess = "GET_CLIENTS_SUCCESS";
export const GetClientsError = "GET_CLIENTS_ERROR";
export const SetClientsSort = "SET_CLIENTS_SORT";
export const GetClientsCsv = "GET_CLIENTS_CSV";
export const GetClientsCsvSuccess = "GET_CLIENTS_CSV_SUCCESS";
export const GetClientsCsvError = "GET_CLIENTS_CSV_ERROR";
export const GetClientsSchema = "GET_CLIENTS_SCHEMA";
export const GetClientsSchemaError = "GET_CLIENTS_SCHEMA_ERROR";
export const SetClientsSchema = "SET_CLIENTS_SCHEMA";
export const GetClientChangeLog = "GET_CLIENT_CHANGE_LOG";
export const GetClientChangeLogSuccess = "GET_CLIENT_CHANGE_LOG_SUCCESS";
export const GetClientChangeLogError = "GET_CLIENT_CHANGE_LOG_ERROR";
export const ToggleAddClientModal = "TOGGLE_ADD_CLIENT_MODAL";
export const ToggleEditClientModal = "TOGGLE_EDIT_CLIENT_MODAL";
export const UpdateClientDetails = "UPDATE_CLIENT_DETAILS";
export const UpdateClientDetailsSuccess = "UPDATE_CLIENT_DETAILS_SUCCESS";
export const UpdateClientDetailsError = "UPDATE_CLIENT_DETAILS_ERROR";
// Client Service
export const GetServiceAbsenceManagementSettings = "GET_SERVICE_ABSENCE_MANAGEMENT_SETTINGS";
export const UpdateServiceAbsenceManagementSettings = "UPDATE_SERVICE_ABSENCE_MANAGEMENT_SETTINGS";
export const GetServicePlatformSettings = "GET_SERVICE_PLARFORM_SETTINGS";
export const GetClientServiceSuccess = "GET_CLIENT_SERVICE_SUCCESS";
export const GetClientServiceError = "GET_CLIENT_SERVICE_ERROR";
export const SetClientServiceSchema = "SET_CLIENTS_SERVICE_SCHEMA";
export const ConfirmAddNewService = "CONFIRM_ADD_NEW_SERVICE";
export const DismissAddNewService = "DISMISS_ADD_NEW_SERVICE";
export const AddNewServiceError = "ADD_NEW_SERVICE_ERROR";
// Admin accounts
export const GetAdminsError = "GET_ADMINS_ERROR";
export const GetAdminSchema = "GET_ADMIN_SCHEMA";
export const SetAdminSchema = "SET_ADMIN_SCHEMA";
export const CreateAdminAccount = "CREATE_ADMIN_ACCOUNT";
export const CreateAdminAccountError = "CREATE_ADMIN_ACCOUNT_ERROR";
export const CreateAdminAccountSuccess = "CREATE_ADMIN_ACCOUNT_SUCCESS";
export const ConfirmCreateAdminAccount = "CONFIRM_CREATE_ADMIN_ACCOUNT";
export const DismissCreateAdminAccount = "DISMISS_CREATE_ADMIN_ACCOUNT";
export const EnableAdminAccount = "ENABLE_ADMIN_ACCOUNT";
export const ConfirmEnableAdminAccount = "CONFIRM_ENABLE_ADMIN_ACCOUNT";
export const DismissEnableAdminAccount = "DISMISS_ENABLE_ADMIN_ACCOUNT";
export const EnableAdminAccountError = "ENABLE_ADMIN_ACCOUNT_ERROR";
export const EnableAdminAccountSuccess = "ENABLE_ADMIN_ACCOUNT_SUCCESS";
export const DisableAdminAccount = "DISABLE_ADMIN_ACCOUNT";
export const DisableAdminAccountError = "DISABLE_ADMIN_ACCOUNT_ERROR";
export const ConfirmDisableAdminAccount = "CONFIRM_DISABLE_ADMIN_ACCOUNT";
export const DismissDisableAdminAccount = "DISMISS_DISABLE_ADMIN_ACCOUNT";

// SLA
export const GetAgreements = "GET_AGREEMENTS";
export const GetAgreementsSuccess = "GET_AGREEMENTS_SUCCESS";
export const GetAgreementsError = "GET_AGREEMENTS_ERROR";

export const GetSlaSchema = "GET_SLA_SCHEMA";
export const GetSlaSchemaSuccess = "GET_SLA_SCHEMA_SUCCESS";
export const GetSlaSchemaError = "GET_SLA_SCHEMA_ERROR";
export const SetSlaSchema = "SET_SLA_SCHEMA";
export const PutAgreements = "PUT_AGREEMENTS";
export const PutAgreementsSuccess = "PUT_AGREEMENTS_SUCCESS";
export const PutAgreementsError = "PUT_AGREEMENTS_ERROR";
export const ToggleSlaClientModal = "TOGGLE_SLA_CLIENT_MODAL";

// SLA Performance
export const GetSlaPerformanceSectionsToggle = "GET_SLA_PERFORMANCE_SECTIONS_TOGGLE";
export const UpdateSlaPerformanceSectionsToggle = "UPDATE_SLA_PERFORMANCE_SECTIONS_TOGGLE";
export const GetSlaPerformanceScopeAndFilters = "GET_SLA_PERFORMANCE_SCOPE_AND_FILTERS";
export const UpdateSlaPerformanceScopeAndFilters = "UPDATE_SLA_PERFORMANCE_SCOPE_AND_FILTERS";
export const ResetSlaPerformanceScopeAndFilters = "RESET_SLA_PERFORMANCE_SCOPE_AND_FILTERS";
export const GetSlaPerformanceReportDetails = "GET_SLA_PERFORMANCE_REPORT_DETAILS";
export const GetSlaPerformanceReportDetailsSuccess = "GET_SLA_PERFORMANCE_REPORT_DETAILS_SUCCESS";
export const GetSlaPerformanceReportDetailsError = "GET_SLA_PERFORMANCE_REPORT_DETAILS_ERROR";
export const GetSlaPerformanceReportDetailsData = "GET_SLA_PERFORMANCE_REPORT_DETAILS_DATA";
export const ExportSlaPerformanceReport = "EXPORT_SLA_PERFORMANCE_REPORT";
export const ExportSlaPerformanceReportSuccess = "EXPORT_SLA_PERFORMANCE_REPORT_SUCCESS";
export const ExportSlaPerformanceReportError = "EXPORT_SLA_PERFORMANCE_REPORT_SUCCESS";

export const SetAdminAccountsAddModal = "SET_ADMIN_ACCOUNTS_ADD_MODAL";

export const ToggleAdditionalOptionsModal = "TOGGLE_ADDITIONAL_OPTIONS_MODAL";
export const ToggleSelfServiceModal = "TOGGLE_SELF_SERVICE_MODAL";
export const ToggleMainOptionsModal = "TOGGLE_MAIN_OPTIONS_MODAL";

// Clients list
export const GetAllClientsList = "GET_ALL_CLIENTS_LIST";
export const GetAllClientsListSuccess = "GET_ALL_CLIENTS_LIST_SUCCESS";
export const GetAllClientsListError = "GET_ALL_CLIENTS_LIST_ERROR";
